import {
  CalendarDateRange,
  ClassCalendarFilters,
} from '../types/ClassCalendar.type';

export const appendClassCalendarFilters = (
  params: URLSearchParams,
  filters: ClassCalendarFilters,
): URLSearchParams => {
  Object.entries(filters).forEach(([key, value]) => {
    if (value && value !== 'All') params.set(key, value);
  });

  return params;
};

export const buildClassCalendarParams = (
  range: CalendarDateRange,
  filters: ClassCalendarFilters,
): URLSearchParams => {
  const params = new URLSearchParams({
    from: range.from,
    toExclusive: range.toExclusive,
  });

  return appendClassCalendarFilters(params, filters);
};
